// Plattform-Versionsanzeige (Sidebar, unten links). KORRIGIERT 2026-09-08: das Frontend wird seit
// dem Docker-Umbau vom 2026-07-16 komplett ins Image gebaut - es gibt kein Laufzeit-config.json-
// Mount mehr, aus dem die Version gelesen werden koennte. Primaerquelle ist deshalb eine
// Build-Zeit-Variable, die die prod-release-Pipeline kuenftig setzt (siehe TASKS.md).
//
// VITE_PLATFORM_VERSION ist noch NICHT von der Pipeline verdrahtet (Cross-Repo/Infra, nicht Teil
// dieser Aenderung) - bis dahin greift der Stage/Dev-Fallback.
export const getPlatformVersionLabel = (): string => {
    const platformVersion = import.meta.env.VITE_PLATFORM_VERSION as string | undefined;
    if (platformVersion) return platformVersion;

    if (import.meta.env.DEV) return 'dev';

    // VITE_BUILD_REF (Commit-Kurz-SHA) ist ebenfalls noch nicht verdrahtet - faellt bis dahin auf
    // den Vite-Modus zurueck (z.B. "stage" oder "production").
    const buildRef = import.meta.env.VITE_BUILD_REF as string | undefined;
    const modeLabel = import.meta.env.MODE || 'stage';
    return buildRef ? `${modeLabel} · ${buildRef}` : modeLabel;
};
